export const getCookie = key => window.Cookies.get(key);
export const removeCookie = key => window.Cookies.remove(key);
export const setCookie = (key, value, attributes) =>
  window.Cookies.set(key, value, attributes);
